import React, { useState } from "react";
import "./ContactUsSection.css";
import ApiService from "../services/ApiService";

const ContactUsSection = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear any previous error when user starts typing
    if (submitError) {
      setSubmitError("");
    }
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError("");

    try {
      const result = await ApiService.submitContactForm(formData);

      if (result.success) {
        setFormSubmitted(true);
        // Reset form data
        setFormData({ name: "", email: "", message: "" });
        // Reset form submission status after 5 seconds
        setTimeout(() => setFormSubmitted(false), 5000);
      } else {
        setSubmitError(
          result.message || "Failed to submit contact form. Please try again."
        );
      }
    } catch (error) {
      console.error("Error submitting contact form:", error);
      setSubmitError(
        "Network error. Please check your connection and try again."
      );
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className="contact-section" id="contact">
      <div className="contact-container">
        <h2>Contact Us</h2>

        <div className="contact-content">
          <div className="contact-info">
            <p className="contact-tagline">
              Have a question or ready to book your next steam wash? We're here
              to help!
            </p>

            <div className="contact-details">
              <div className="detail-group">
                <h3>Steam and Drive Car Wash</h3>
                <p>Hyderabad, Telangana, India</p>
              </div>

              <div className="detail-group">
                <h3>Contact Information</h3>
                <p>
                  <strong>Phone:</strong> (91) 8499078968
                </p>
                <p>
                  <strong>Email:</strong> support@steamanddrive.com
                </p>
              </div>

              <div className="detail-group">
                <h3>Working Hours</h3>
                <p>
                  <strong>Mon – Fri:</strong> 9:00 AM – 8:00 PM
                </p>
                <p>
                  <strong>Sat – Sun:</strong> 8:00 AM – 9:00 PM
                </p>
              </div>
            </div>
          </div>

          <div className="contact-form-container">
            <h3>Or use our quick contact form below:</h3>

            <form className="contact-form" onSubmit={handleSubmit}>
              <div className="form-group">
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your Name"
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Your Email"
                  required
                  className="form-input"
                />
              </div>
              <div className="form-group">
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Message"
                  required
                  className="form-textarea"
                  rows="5"
                ></textarea>
              </div>
              <div className="form-disclaimer">
                By submitting this form, you agree to our{" "}
                <a href="/terms">Terms and Conditions</a>.
              </div>{" "}
              <button
                type="submit"
                className="form-button"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Sending..." : "Send Message"}
              </button>
              {submitError && <div className="form-error">{submitError}</div>}
              {formSubmitted && (
                <div className="form-success">
                  Thank you! Your message has been sent successfully.
                </div>
              )}
            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactUsSection;
